import type { IArticle } from './../types';

export default (nodes: any, id: IArticle['id'], type: IArticle['type']) => {
	const stack = [...nodes as any];

	while (stack.length > 0) {
		const currentArticle = stack.pop();

		if (!currentArticle) break;

		if (currentArticle.type === type && currentArticle.id === id) {
			return currentArticle;
		}

		if (currentArticle?.type === 'group' && currentArticle?.content?.length > 0) {
			stack.push(...currentArticle.content);
		}
	}

	return undefined;
};
